const Actions = {
  MATRIX_MODEL: 'matrix_model',
  SNIPPET: 'snippet',
};

const ActionsCopyMap = {
  MATRIX_MODEL: 'run matrix',
};

const ActionOptions = {
  MATRIX_MODELS: {
    TOKEN: 'matrix_model_token',
    VERSION: 'matrix_model_public_version',
  },
};

export const APPLICABLE_WHAT_IF_WORKFLOW_TYPES = [
  'person',
  'business',
];

const ATTRIBUTE_TYPES = {
  INPUT: 'input',
  OUTPUT: 'output',
};

const INPUT_ATTRIBUTE_DATA_TYPES = {
  BOOLEAN: 'boolean',
  DATE: 'date',
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  STRING: 'string',
  TIMESTAMP: 'timestamp',
};

const INPUT_ATTRIBUTE_DATA_TYPES_ARR = Object.values(INPUT_ATTRIBUTE_DATA_TYPES);

const OUTPUT_ATTRIBUTE_DATA_TYPES = {
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  STRING: 'string',
};

const OUTPUT_ATTRIBUTE_DATA_TYPES_ARR = Object.values(OUTPUT_ATTRIBUTE_DATA_TYPES);

const OUTPUT_ATTRIBUTE_NUMBER_DATA_TYPES_ARR = [
  OUTPUT_ATTRIBUTE_DATA_TYPES.DECIMAL,
  OUTPUT_ATTRIBUTE_DATA_TYPES.INTEGER,
];

const OUTPUT_ATTRIBUTE_DEFAULT_EXPRESSION_BY_DATA_TYPE = {
  [OUTPUT_ATTRIBUTE_DATA_TYPES.DECIMAL]: [1],
  [OUTPUT_ATTRIBUTE_DATA_TYPES.INTEGER]: [1],
  [OUTPUT_ATTRIBUTE_DATA_TYPES.STRING]: [],
};

const PORTFOLIO_FREQUENCIES = {
  SCHEDULED_CRON: 'scheduled-cron',
  EVENT_DRIVEN: 'event-driven',
};

const WORKFLOW_STATUS_TYPES = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DRAFT: 'draft',
  INACTIVE: 'inactive',
};

const NUM_DAYS_WORKFLOW_VALIDATION = 10;

/*
Normally published attribute action options are saved on the published attribute.
However these options are unique to the workflow version, so we must continue to save them there.
*/
const PA_OUTPUT_ACTION_OPTIONS_TO_SAVE_TO_WORKFLOW = {
  USE_JQ: 'use_jq',
  JQ_FUNCTION: 'jq_function',
  EXPRESSION: 'expression',
};

export {
  Actions,
  ActionsCopyMap,
  ActionOptions,
  ATTRIBUTE_TYPES,
  INPUT_ATTRIBUTE_DATA_TYPES,
  INPUT_ATTRIBUTE_DATA_TYPES_ARR,
  NUM_DAYS_WORKFLOW_VALIDATION,
  OUTPUT_ATTRIBUTE_DATA_TYPES,
  OUTPUT_ATTRIBUTE_DATA_TYPES_ARR,
  OUTPUT_ATTRIBUTE_DEFAULT_EXPRESSION_BY_DATA_TYPE,
  OUTPUT_ATTRIBUTE_NUMBER_DATA_TYPES_ARR,
  PA_OUTPUT_ACTION_OPTIONS_TO_SAVE_TO_WORKFLOW,
  PORTFOLIO_FREQUENCIES,
  WORKFLOW_STATUS_TYPES,
};

// Create Outcome error text
export const CREATE_OUTCOME_GENERIC_ERROR = 'Couldn\'t create outcome. Please try a different outcome name or try again later.';

